export type ColumnCommonConfig = keyof typeof columnsCommonConfig;

export const columnsCommonConfig = {
    clusterName: {
        id: 'clusterName',
        width: 300,
        size: 300,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
        disableGroupBy: false,
        isDisableReorder: true,
        isDisableVisibility: true,
    },
    activity: {
        id: 'activity',
        width: 274,
        size: 274,
        isDisableReorder: true,
        isDisableVisibility: true,
    },
    activityId: {
        id: 'activityId',
    },
    riskIndicators: {
        id: 'riskIndicators',
        disableSortBy: true,
        enableSorting: false,
    },
    assignee: {
        id: 'assignee',
        width: 100,
        size: 100,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    status: {
        id: 'status',
        width: 150,
        size: 150,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
        isDisableReorder: true,
        isDisableVisibility: true,
    },
    projectNameSubProgram: {
        id: 'projectNameSubProgram',
        width: 530,
        size: 530,
        isDisableReorder: true,
        isDisableVisibility: true,
    },
    activityType: {
        id: 'activityType',
        width: 120,
        size: 120,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    recommendation: {
        id: 'recommendation',
        width: 460,
        size: 460,
        isDisableReorder: true,
        isDisableVisibility: true,
    },
    projectName: {
        id: 'projectName',
        width: 130,
        size: 130,
    },
    contractName: {
        id: 'contractName',
        width: 130,
        size: 130,
    },
    versionName: {
        id: 'versionName',
        width: 220,
        size: 220,
    },
    forecastDuration: {
        id: 'forecastDuration',
        width: 140,
        size: 140,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    actualDuration: {
        id: 'actualDuration',
        width: 90,
        size: 90,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    remainingDuration: {
        id: 'remainingDuration',
        width: 120,
        size: 120,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    forecastOverrun: {
        id: 'forecastOverrun',
        width: 120,
        size: 120,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    startDate: {
        id: 'startDate',
        width: 140,
        size: 140,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    finishDate: {
        id: 'finishDate',
        width: 140,
        size: 140,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    versionDate: {
        id: 'versionDate',
        width: 140,
        size: 140,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    duration: {
        id: 'duration',
        width: 120,
        size: 120,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    progress: {
        id: 'progress',
        width: 80,
        size: 80,
    },
    risk: {
        id: 'risk',
        width: 80,
        size: 80,
    },
    quality: {
        id: 'quality',
        width: 80,
        size: 80,
    },
    submittedCompletionDate: {
        id: 'submittedCompletionDate',
        width: 200,
        size: 200,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    criticalityAdherence: {
        id: 'criticalityAdherence',
        width: 180,
        size: 180,
    },
    milestoneAdherence: {
        id: 'milestoneAdherence',
        width: 180,
        size: 180,
    },
    latestVersionCategory: {
        id: 'latestVersionCategory',
        width: 130,
        size: 130,
    },
    latestVersionSeverity: {
        id: 'latestVersionSeverity',
        width: 160,
        size: 160,
    },
    submittedDurationComplete: {
        id: 'submittedDurationComplete',
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
        width: 130,
        size: 130,
    },
    narrative: {
        id: 'narrative',
        width: 370,
        size: 370,
    },
    successorsInFragnet: {
        id: 'successorsInFragnet',
        width: 120,
        size: 120,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    totalSuccessors: {
        id: 'totalSuccessors',
        width: 120,
        size: 120,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    float: {
        id: 'float',
        width: 120,
        size: 120,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    criticalPath: {
        id: 'criticalPath',
        width: 100,
        size: 100,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    criticalityScore: {
        id: 'criticalityScore',
        width: 120,
        size: 120,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    predecessors: {
        id: 'predecessors',
        width: 90,
        size: 90,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    successors: {
        id: 'successors',
        width: 90,
        size: 90,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    details: {
        id: 'details',
        width: 500,
        size: 500,
    },
    plannedDuration: {
        id: 'plannedDuration',
        width: 140,
        size: 140,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    completedDuration: {
        id: 'completedDuration',
        width: 90,
        size: 90,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    relationshipType: {
        id: 'relationshipType',
        width: 110,
        size: 110,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    successorName: {
        id: 'successorName',
        width: 190,
        size: 190,
    },
    plannedStartDate: {
        id: 'plannedStartDate',
        width: 140,
        size: 140,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    plannedFinishDate: {
        id: 'plannedFinishDate',
        width: 140,
        size: 140,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    baselineStartDate: {
        id: 'baselineStartDate',
        width: 140,
        size: 140,
        fixedSize: true,
        meta: {
            isFixedSize: true,
            columnLabel: 'Baseline Version Start Date',
        },
    },
    baselineFinishDate: {
        id: 'baselineFinishDate',
        width: 140,
        size: 140,
        fixedSize: true,
        meta: {
            isFixedSize: true,
            columnLabel: 'Baseline Version Finish Date',
        },
    },
    actualStartDate: {
        id: 'actualStartDate',
        width: 140,
        size: 140,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    actualFinishDate: {
        id: 'actualFinishDate',
        width: 140,
        size: 140,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    currentStartDate: {
        id: 'currentStartDate',
        width: 140,
        size: 140,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    currentFinishDate: {
        id: 'currentFinishDate',
        width: 140,
        size: 140,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    durationOverrun: {
        id: 'durationOverrun',
        width: 140,
        size: 140,
    },
    overrunDays: {
        id: 'overrunDays',
        width: 140,
        size: 140,
    },
    overrunPercent: {
        id: 'overrunPercent',
        width: 90,
        size: 90,
    },
    numOfPredecessors: {
        id: 'numOfPredecessors',
        width: 130,
        size: 130,
    },
    numOfSuccessors: {
        id: 'numOfSuccessors',
        width: 130,
        size: 130,
    },
    projectWeekStart: {
        id: 'projectWeekStart',
        width: 140,
        size: 140,
    },
    projectWeekFinish: {
        id: 'projectWeekFinish',
        width: 140,
        size: 140,
    },
    projectMonthStart: {
        id: 'projectMonthStart',
        width: 140,
        size: 140,
    },
    projectMonthFinish: {
        id: 'projectMonthFinish',
        width: 140,
        size: 140,
    },
    lateStart: {
        id: 'lateStart',
        width: 90,
        size: 90,
    },
    lateFinish: {
        id: 'lateFinish',
        width: 90,
        size: 90,
    },
    parentName: {
        id: 'parentName',
        width: 370,
        size: 370,
    },
    grandParentName: {
        id: 'grandParentName',
        width: 370,
        size: 370,
    },
    rowOptions: {
        id: 'rowOptions',
        accessor: 'rowOptions',
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
        Filter: false,
        disableSortBy: true,
        size: 150,
    },
    lastSubmittedStatus: {
        id: 'lastSubmittedStatus',
        width: 120,
        size: 120,
    },
    originalStatus: {
        id: 'originalStatus',
        width: 120,
        size: 120,
    },
    tagList: {
        id: 'tagList',
        width: 400,
        size: 400,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    resourceNameList: {
        id: 'resourceNameList',
        width: 600,
        size: 600,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    allBudgetResource: {
        id: 'allBudgetResource',
        width: 90,
        size: 90,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    allActualResource: {
        id: 'allActualResource',
        width: 90,
        size: 90,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    externalRelation: {
        id: 'externalRelation',
        size: 150,
    },
    previousVersionStartDate: {
        id: 'previousVersionStartDate',
        width: 170,
        size: 170,
    },
    previousVersionFinishDate: {
        id: 'previousVersionFinishDate',
        width: 170,
        size: 170,
    },
    previousVersionStartVariance: {
        id: 'previousVersionStartVariance',
        size: 150,
    },
    previousVersionFinishVariance: {
        id: 'previousVersionFinishVariance',
        size: 150,
    },
    baselineStartVariance: {
        id: 'baselineStartVariance',
        width: 170,
        size: 170,
    },
    baselineFinishVariance: {
        id: 'baselineFinishVariance',
        width: 170,
        size: 170,
    },
    baselineDuration: {
        id: 'baselineDuration',
        size: 170,
    },
    programTags: {
        id: 'programTags',
        width: 250,
        size: 250,
    },
    latestVersion: {
        id: 'latestVersion',
        width: 160,
        size: 160,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    resourceName: {
        id: 'resourceName',
        size: 300,
    },
    resourceType: {
        id: 'resourceType',
        size: 100,
        fixedSize: true,
    },
    comparedBudgetResource: {
        id: 'comparedBudgetResource',
        size: 100,
        fixedSize: true,
    },
    actualResource: {
        id: 'actualResource',
        size: 100,
        fixedSize: true,
    },
    remainingResource: {
        id: 'remainingResource',
        size: 100,
        fixedSize: true,
    },
    floatVariance: {
        id: 'floatVariance',
        width: 120,
        size: 120,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    criticalPathChange: {
        id: 'criticalPathChange',
        width: 90,
        size: 90,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    remainingDurationVariance: {
        id: 'remainingDurationVariance',
        width: 90,
        size: 90,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    wbsLevel: {
        id: 'wbsLevel',
        width: 70,
        size: 70,
    },
    finishVarianceFromBaseline: {
        id: 'finishVarianceFromBaseline',
        width: 170,
        size: 170,
    },
    startVarianceFromBaseline: {
        id: 'startVarianceFromBaseline',
        width: 170,
        size: 170,
    },
    startDateVariance: {
        id: 'startDateVariance',
        width: 170,
        size: 170,
    },
    finishDateVariance: {
        id: 'finishDateVariance',
        width: 170,
        size: 170,
    },
    spi: {
        id: 'spi',
        width: 80,
        size: 80,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    criticalityWeightedPlanned: {
        id: 'criticalityWeightedPlanned',
        width: 120,
        size: 120,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    criticalityWeightedActual: {
        id: 'criticalityWeightedActual',
        width: 120,
        size: 120,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    qualityNumeric: {
        id: 'qualityNumeric',
        width: 90,
        size: 90,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },

    riskNumeric: {
        id: 'riskNumeric',
        width: 90,
        size: 90,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    lastModified: {
        id: 'lastModified',
        width: 150,
        size: 150,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    sharedWith: {
        id: 'sharedWith',
        width: 200,
        size: 200,
    },
    cadence: {
        id: 'cadence',
        width: 120,
        size: 120,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    dataUpdate: {
        id: 'dataUpdate',
        width: 300,
        size: 300,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    reportProjects: {
        id: 'reportProjects',
        size: 430,
        fixedSize: true,
    },
    reportName: {
        id: 'reportName',
        width: 400,
        size: 400,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    registerName: {
        id: 'registerName',
        width: 90,
        size: 90,
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
    },
    'select-col': {
        id: 'select-col',
        accessor: '',
        fixedSize: true,
        meta: {
            isFixedSize: true,
        },
        Filter: false,
        disableSortBy: true,
        size: 50,
        isDisableReorder: true,
        isDisableVisibility: true,
    },
    reportTags: {
        id: 'reportTags',
        width: 250,
        size: 250,
    },
    reportLastUserUpdated: {
        id: 'reportLastUserUpdated',
        width: 120,
        size: 120,
    },
    reportSettingsUserName: {
        id: `reportSettingsUserName`,
        width: 150,
        size: 150,
    },
    reportSettingsProjectAccess: {
        id: 'reportSettingsProjectAccess',
        width: 250,
        size: 250,
    },
    reportSettingsAccess: {
        id: 'reportSettingsAccess',
        width: 50,
        size: 50,
    },
    reportSettingsNotifyOnDataUpload: {
        id: 'reportSettingsNotifyOnDataUpload',
        width: 90,
        size: 90,
    },
    pivotTableGroupByName: {
        id: 'pivotTableGroupBy',
        width: 400,
        size: 400,
        isDisableReorder: true,
        isDisableVisibility: true,
    },

    pivotTableGroupByStatus: {
        id: 'pivotTableGroupByStatus',
        width: 200,
        size: 200,
    },

    pivotTableGroupByStatusToDo: {
        id: 'pivotTableGroupByStatusToDo',
        width: 90,
        size: 90,
    },
    pivotTableGroupByStatusInProgress: {
        id: 'pivotTableGroupByStatusInProgress',
        width: 90,
        size: 90,
    },
    pivotTableGroupByStatusDone: {
        id: 'pivotTableGroupByStatusDone',
        width: 90,
        size: 90,
    },
    pivotTableFinishVariance: {
        id: 'pivotTableFinishVariance',
        width: 90,
        size: 90,
    },
    totalFloatAvg: {
        id: 'totalFloatAvg',
        width: 100,
        size: 100,
    },
    lateStartAvg: {
        id: 'lateStartAvg',
        width: 100,
        size: 100,
    },
    lateStartDelayedPercent: {
        id: 'lateStartDelayedPercent',
        width: 90,
        size: 90,
    },
    lateStartEarlyPercent: {
        id: 'lateStartEarlyPercent',
        width: 100,
        size: 100,
    },
    lateFinishDelayedPercent: {
        id: 'lateFinishDelayedPercent',
        width: 100,
        size: 100,
    },
    lateFinishEarlyPercent: {
        id: 'lateFinishEarlyPercent',
        width: 100,
        size: 100,
    },
    durationAvg: {
        id: 'durationAvg',
        width: 100,
        size: 100,
    },
    durationUnderrunPercent: {
        id: 'durationUnderrunPercent',
        width: 100,
        size: 100,
    },
    budgetResourceMedian: {
        id: 'budgetResourceMedian',
        width: 100,
        size: 100,
    },
    budgetResourceSum: {
        id: 'budgetResourceSum',
        width: 100,
        size: 100,
    },
    remainingResourceSum: {
        id: 'remainingResourceSum',
        width: 100,
        size: 100,
    },
    actualResourceSum: {
        id: 'actualResourceSum',
        width: 100,
        size: 100,
    },
    criticalScoreMedian: {
        id: 'criticalScoreMedian',
        width: 100,
        size: 100,
    },
    completedDurationMedian: {
        id: 'completedDurationMedian',
        width: 100,
        size: 100,
    },
    pivotTableCompletedDurationP80: {
        id: 'pivotTableCompletedDurationP80',
        width: 140,
        size: 140,
    },
    criticalityPlannedPercent: {
        id: 'criticalityPlannedPercent',
        width: 140,
        size: 140,
    },
    criticalityActualPercent: {
        id: 'criticalityActualPercent',
        width: 130,
        size: 130,
    },
    criticalityScheduleAdherence: {
        id: 'criticalityScheduleAdherence',
        width: 100,
        size: 100,
    },
};
